import { ModelPathEnum } from 'app/shared/enums';
import { getTravelQuotation } from 'app/services/businessFunctionHelpers';
import { TravelQuotationService } from 'app/services/travelQuotation.service';

const clearTravelerPesel = (
  travelerPeselModelPath: ModelPathEnum,
  initialRun: boolean
) => {
  const { id: quotationId } = getTravelQuotation();

  if (initialRun) {
    return;
  }

  TravelQuotationService.update(quotationId, travelerPeselModelPath, null);
};

export const travelers = {
  traveler1AgeChange(initialRun: boolean) {
    clearTravelerPesel(ModelPathEnum.TravelTraveler1Pesel, initialRun);
  },
  traveler2AgeChange(initialRun: boolean) {
    clearTravelerPesel(ModelPathEnum.TravelTraveler2Pesel, initialRun);
  },
  traveler3AgeChange(initialRun: boolean) {
    clearTravelerPesel(ModelPathEnum.TravelTraveler3Pesel, initialRun);
  },
  traveler4AgeChange(initialRun: boolean) {
    clearTravelerPesel(ModelPathEnum.TravelTraveler4Pesel, initialRun);
  },
  traveler5AgeChange(initialRun: boolean) {
    clearTravelerPesel(ModelPathEnum.TravelTraveler5Pesel, initialRun);
  },
  traveler6AgeChange(initialRun: boolean) {
    clearTravelerPesel(ModelPathEnum.TravelTraveler6Pesel, initialRun);
  },
  traveler7AgeChange(initialRun: boolean) {
    clearTravelerPesel(ModelPathEnum.TravelTraveler7Pesel, initialRun);
  },
  traveler8AgeChange(initialRun: boolean) {
    clearTravelerPesel(ModelPathEnum.TravelTraveler8Pesel, initialRun);
  },
  traveler9AgeChange(initialRun: boolean) {
    clearTravelerPesel(ModelPathEnum.TravelTraveler9Pesel, initialRun);
  },
  traveler10AgeChange(initialRun: boolean) {
    clearTravelerPesel(ModelPathEnum.TravelTraveler10Pesel, initialRun);
  },
};
